import { Menu, UnstyledButton, rem } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { Wrapper } from './IconMenu.style';

export type IconMenuProps = {
  actions: IRowAction[];
  onAction: OnAction;
  itemId?: string;
  color?: string;
};

export function IconMenu(props: IconMenuProps) {
  const { actions, itemId, color = 'white' } = props;

  function onAction(action: IRowAction, ev: React.MouseEvent<HTMLButtonElement>) {
    ev.stopPropagation();
    props.onAction({ type: action.actionType!, verb: action.id, id: itemId });
  }

  function renderAction(action: IRowAction) {
    const { id, title, color, iconName } = action;

    const Cmp = (icons as any)[iconName];

    return (
      <Menu.Item
        key={id}
        color={color}
        leftSection={Cmp && <Cmp style={{ width: rem(14), height: rem(14) }} />}
        onClick={(ev) => onAction(action, ev)}
      >
        {title}
      </Menu.Item>
    );
  }

  function onClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
  }

  function renderActions() {
    return actions.map((action) => renderAction(action));
  }

  return (
    <Wrapper className='IconMenu-wrapper' data-testid='IconMenu-wrapper'>
      <Menu shadow='md' width={200} offset={-2}>
        <Menu.Target>
          <UnstyledButton onClick={onClick}>
            <icons.IconDotsVertical size={20} color={color} />
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>{renderActions()}</Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default IconMenu;
